export default class Filter {

    static counter = 0;

    static endpoint;

    static config;

    id;

    resource;

    filterEndpoint;

    isCharacteristicValue = false;

    operators = [];

    operator = null;

    value = "";

    constructor(resource = "", value = "") {
        if (!resource) {
            resource = this.getResources()[0].name;
        }
        this.id = ++Filter.counter;
        this.setResource(resource, value);
    }

    static setEndpoint(value) {
        Filter.endpoint = value;
    }

    static getForResource() {
        if (Filter.endpoint === 'pois') {
            return 'for_poi';
        } else if (Filter.endpoint === 'events') {
            return 'for_event';
        } else if (Filter.endpoint === 'routes') {
            return 'for_route';
        } else if (Filter.endpoint === 'public_transport_lines') {
            return 'for_public_transport_line_product';
        } else if (Filter.endpoint === 'public_transport_stops') {
            return 'for_public_transport_stop';
        }
    }

    getResources() {
        return Filter.config.filter.filter(filterItem => {
            return filterItem.hasOwnProperty('validFor') ? filterItem.validFor.includes(Filter.endpoint) : filterItem;
        });
    }

    setResource(res, value = "") {
        let operatorVal;
        this.operator = null;
        this.isCharacteristicValue = !isNaN(res);

        const matches = res.match(/_ids_(.*)/);
        if (matches) {
            res = res.replace(matches[0], "s.id");
            operatorVal = matches[0];
        }

        // Set fromUrl characteristic values
        if (res === 'characteristic_values') {
            operatorVal = value.replace(/[0-9a-zA-Z]/g, "");
            this.isCharacteristicValue = true;
            const characteristicValuesArray = value.split(operatorVal);
            res = characteristicValuesArray[0];
            value = characteristicValuesArray[1];
        }

        this.resource = this.isCharacteristicValue ? Filter.config.datasources.characteristics_for_groups.find(item => item.id === parseInt(res)) : Filter.config.filter.find(item => item.name === res);
        this.filterSet = Filter.config.filterSets[this.resource.set];
        this.setOperators();

        if (operatorVal || this.filterSet.operators.length) {
            operatorVal = operatorVal || this.filterSet.operators[0].value;
            this.setOperator(operatorVal);
        }

        this.setInputfield();
        this.setDatasource();
        this.setFilterEndpoint();

        if (value) {
            this.setValue(value);
        } else {
            this.setDefaultValue();
        }
    }

    getResource() {
        return this.resource;
    }

    setDefaultValue() {
        this.value = "";
        if (this.filterSet.hasOwnProperty('value')) {
            this.setValue(this.filterSet.value);
        }
    }

    setFilterEndpoint() {
        this.filterEndpoint = this.resource.dataportalEndpoint;
    }

    getFilterEndpoint() {
        return this.filterEndpoint;
    }

    setOperators() {
        this.operators = this.filterSet.operators;
    }

    setInputfield() {
        this.inputfield = this.filterSet.inputfield;
    }

    getInputfield() {
        return this.inputfield;
    }

    setOperator(operatorValue) {
        this.operator = this.filterSet.operators.find(operator => operator.value === operatorValue);
    }

    getOperator() {
        return this.operator;
    }

    setValue(value) {
        this.value = value;
    }

    getValue() {
        return this.value;
    }

    setDatasource() {
        if (this.resource.hasOwnProperty("datasource")) {
            this.datasource = Filter.config.datasources[this.resource.datasource];
        }
    }

    getDatasource() {
        return this.datasource;
    }

    getFilterUrlString() {
        const resource = this.getResource();
        const operator = this.getOperator();
        const value = this.getValue();

        if (this.isCharacteristicValue) {
            return `filter[characteristic_values]=${this.resource.id}${this.operator.value}${value}`;
        }

        const resourceName = this.generateResourceName(resource, operator);
        return `filter[${resourceName}]=${value}`;
    }

    generateResourceName(resource, operator) {
        if (operator == null) {
            return resource.name
        }
        return operator.hasOwnProperty('filterResourceName') ? resource[operator.filterResourceName] : resource.name;
    }
}